import { CHANGE_LANGUAGE } from './action';
import { getCognitoInfo } from '../../utils/auth/cognito';

const initialState = {
  languageCode: getCognitoInfo().lang || 'en'
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        languageCode: action.payload.languageCode
      };
    default:
      return state;
  }
}
